<script>
import axios from 'axios'

const MAX_RETRIES = 2
const RETRY_DELAY_MS = 1000
const REQUEST_TIMEOUT_MS = 30000

axios.interceptors.response.use(
    response => {
        return response
    },
    error => {
        if (!error.response) {
            // Network error - no response received
        }

        return Promise.reject(error)
    },
)

function isRetryable(error) {
    if (!error.response) return true // network error
    const status = error.response.status
    return status >= 500 || status === 408 || status === 429
}

function isReadRequest(method, endpoint) {
    const normalizedMethod = String(method).toUpperCase()
    if (normalizedMethod === 'GET' || normalizedMethod === 'HEAD' || normalizedMethod === 'OPTIONS') return true
    // These API reads use POST for their filters. Mutations have no idempotency
    // key: after a timeout the server may already have saved the record.
    return normalizedMethod === 'POST' && /\/(?:filter|search)\//.test(String(endpoint).split('?')[0])
}

async function sleep(ms) {
    return new Promise(resolve => setTimeout(resolve, ms))
}

export default {
    getDefaultHeader: vue => {
        let header = {
            'Content-Type': 'application/json',
            Authorization: vue.$session.get('token'),
        }
        if (vue.$session.get('correlationId') && vue.$session.get('correlationId') != 'undefined') {
            header['x-correlation-id'] = vue.$session.get('correlationId')
        }
        return header
    },
    do: async (vue, method, headers, params, endpoint, callbackSuccess, callbackError) => {
        for (let attempt = 0; attempt <= MAX_RETRIES; attempt++) {
            let receivedResponse = false
            try {
                let res = await axios({
                    method: method,
                    url: endpoint,
                    headers: headers,
                    data: params,
                    timeout: REQUEST_TIMEOUT_MS,
                })
                receivedResponse = true
                if (callbackSuccess) {
                    callbackSuccess(res.data, res)
                } else {
                    return res
                }
                return
            } catch (err) {
                if (err.response && err.response.status === 401 && err.response?.data?.messageId !== 'response.user.archived' && err.response?.data?.messageId !== 'response.company.archived' && err.response?.data?.messageId !== 'response.user.password.incorrect') {
                    vue.$router.push('/')
                    return
                }

                if (!receivedResponse && isReadRequest(method, endpoint) && attempt < MAX_RETRIES && isRetryable(err)) {
                    await sleep(RETRY_DELAY_MS * (attempt + 1))
                    continue
                }

                if (callbackError) {
                    return callbackError(err)
                }
                return err
            }
        }
    },
}
</script>
